import { useEffect, useState } from "react";

const NAV_LINKS = [
  { href: "#hot", label: "今日吃瓜" },
  { href: "#archive", label: "完整存档" },
  { href: "#timeline", label: "深扒时间线" },
  { href: "#about", label: "关于我们" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 24);
      // highlight active anchor
      const ids = NAV_LINKS.map((l) => l.href.slice(1));
      let current = "";
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 140) current = id;
      }
      setActive(current);
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={
        "fixed inset-x-0 top-0 z-50 transition-all duration-300 " +
        (scrolled
          ? "border-b border-background-200 bg-background-50/90 backdrop-blur-md"
          : "border-b border-transparent bg-background-50")
      }
    >
      <nav className="flex h-16 items-center justify-between px-4 md:px-6 lg:px-10">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap" aria-label="吃瓜大全 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-eye-2-line text-lg"></i>
          </span>
          <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
            吃瓜<span className="text-primary-600">大全</span>
          </span>
          <span className="ml-1 hidden rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-700 sm:inline-block">
            完整存档站
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={
                "rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors " +
                (active === l.href.slice(1)
                  ? "bg-secondary-100 font-medium text-secondary-900"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950")
              }
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#archive"
            className="hidden items-center gap-2 rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-timer-flash-line text-base"></i>
            去存档吃瓜
          </a>
          <button
            onClick={() => setOpen(!open)}
            aria-label="展开导航菜单"
            className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-900 lg:hidden"
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </nav>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      ) : null}
    </header>
  );
}